module.exports = __webpack_public_path__ + "img/banner.de0e1437.jpg";